var exports = {
  "R": "x127c5a35--86301c--hidden",
  "MM": "x127c5a35--86301c--align",
  "kL": "x127c5a35--86301c--container",
  "AS": "x127c5a35--86301c--item",
  "yy": "x127c5a35--86301c--fullwidth",
};

module.exports = exports;
